import React, { useEffect, useState } from "react";
import "./AnnualMalarHistory.scss";
import Headernav from "../header_nav/Headernav";
import axios from "axios";
import { API_BASE } from "../apiBase";

const AnnualMalarHistory = () => {
  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const [yearStats, setYearStats] = useState({});
  const [receipts, setReceipts] = useState([]);
  const [receiptFrom, setReceiptFrom] = useState("");
  const [receiptTo, setReceiptTo] = useState("");
  const [receiptsLoading, setReceiptsLoading] = useState(false);
  const [message, setMessage] = useState("");

  const fetchYears = async () => {
    try {
      const response = await axios.get(`${API_BASE}/annual_malar_years.php?ensure_current=1`);
      const yearList = Array.isArray(response.data) ? response.data : [];
      setYears(yearList);
      if (yearList.length > 0) {
        setSelectedYear(yearList[0]);
      }
    } catch (error) {
      console.log(error);
      setMessage("ஆண்டு பட்டியல் பெற முடியவில்லை.");
    }
  };

  const fetchYearStats = async () => {
    try {
      const response = await axios.get(`${API_BASE}/annual_malar_stats.php`);
      const stats = {};
      if (Array.isArray(response.data)) {
        response.data.forEach((row) => {
          stats[row.year] = Number(row.received_count || 0);
        });
      }
      setYearStats(stats);
    } catch (error) {
      console.log(error);
      setMessage("புள்ளிவிவரம் பெற முடியவில்லை.");
    }
  };

  const fetchReceipts = async (year, fromDate, toDate) => {
    if (!year) {
      return;
    }
    setReceiptsLoading(true);
    setMessage("");
    try {
      const params = new URLSearchParams({ year });
      if (fromDate) {
        params.append("from", fromDate);
      }
      if (toDate) {
        params.append("to", toDate);
      }
      const response = await axios.get(`${API_BASE}/annual_malar_receipts.php?${params.toString()}`);
      setReceipts(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.log(error);
      setReceipts([]);
      setMessage("வரலாறு பெற முடியவில்லை.");
    }
    setReceiptsLoading(false);
  };

  useEffect(() => {
    fetchYears();
    fetchYearStats();
  }, []);

  useEffect(() => {
    if (selectedYear) {
      fetchReceipts(selectedYear, receiptFrom, receiptTo);
    }
  }, [selectedYear]);

  const handleYearSelect = (year) => {
    setSelectedYear(year);
    setReceipts([]);
  };

  return (
    <>
      <Headernav />
      <div className="annual-history-page">
        <div className="annual-history-content">
          <h2 className="annual-history-title">ஆண்டு மலர் வரலாறு</h2>

          <div className="history-year-grid">
            {years.map((year) => (
              <button
                key={year}
                type="button"
                className={`history-year-card ${selectedYear === year ? "active" : ""}`}
                onClick={() => handleYearSelect(year)}
              >
                <div className="history-year-number">{year}</div>
                <div className="history-year-label">ஆண்டு மலர்</div>
                <div className="history-year-stats">
                  வழங்கப்பட்டது: {yearStats[year] || 0}
                </div>
              </button>
            ))}
          </div>

          {selectedYear && (
            <div className="history-panel">
              <div className="history-summary">
                <div className="summary-card">
                  <div className="summary-label">மொத்தம் வழங்கப்பட்டது</div>
                  <div className="summary-value">{yearStats[selectedYear] || 0}</div>
                </div>
              </div>

              <div className="receipts-panel">
                <div className="receipts-header">
                  <div className="receipts-title">விநியோக பட்டியல்</div>
                  <div className="receipts-filters">
                    <div className="filter-field">
                      <label>From</label>
                      <input
                        type="date"
                        value={receiptFrom}
                        onChange={(e) => setReceiptFrom(e.target.value)}
                      />
                    </div>
                    <div className="filter-field">
                      <label>To</label>
                      <input
                        type="date"
                        value={receiptTo}
                        onChange={(e) => setReceiptTo(e.target.value)}
                      />
                    </div>
                    <button
                      type="button"
                      className="filter-button"
                      onClick={() => fetchReceipts(selectedYear, receiptFrom, receiptTo)}
                      disabled={receiptsLoading}
                    >
                      Load
                    </button>
                  </div>
                </div>

                {message && <div className="history-message">{message}</div>}

                {receiptsLoading && <div className="receipts-loading">Loading...</div>}

                {!receiptsLoading && !message && receipts.length === 0 && (
                  <div className="receipts-empty">இந்த ஆண்டுக்கு பதிவு இல்லை.</div>
                )}

                {!receiptsLoading && receipts.length > 0 && (
                  <div className="receipts-table">
                    <div className="receipts-row receipts-head">
                      <div>நேரம்</div>
                      <div>உறுப்பினர்</div>
                      <div>பெற்றவர்</div>
                      <div>பதிவு செய்தவர்</div>
                      <div>விளக்கம்</div>
                    </div>
                    {receipts.map((row, index) => (
                      <div className="receipts-row" key={`${row.member_no}-${index}`}>
                        <div>{row.received_at}</div>
                        <div>
                          {row.member_name || "Unknown"} #{row.member_no}
                        </div>
                        <div>{row.received_by_type}</div>
                        <div>{row.received_by_name || "-"}</div>
                        <div>{row.received_by_desc || "-"}</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AnnualMalarHistory;
